import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import AuthLayout from '../components/AuthLayout';
import FormField  from '../components/FormField';
import Button     from '../components/Button';
import Alert      from '../components/Alert';

export default function Register() {
  const [form, setForm]       = useState({ email: '', math_answer: '', image_answer: '', terms_agree: false });
  const [mathQ, setMathQ]     = useState('');
  const [captchaImg, setCaptchaImg] = useState('');
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const loadCaptchas = async () => {
    const m = await api.get('/auth/captcha/math');
    setMathQ(m.data.question);
    const i = await api.get('/auth/captcha/image');
    setCaptchaImg(i.data.image);
  };

  useEffect(() => { loadCaptchas(); }, []);

  const handle = e => {
    const val = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(f => ({ ...f, [e.target.name]: val }));
  };

  const submit = async e => {
    e.preventDefault();
    setError(''); setSuccess('');
    setLoading(true);
    try {
      const r = await api.post('/auth/register', form);
      setSuccess(r.data.message);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
      await loadCaptchas();
      setForm(f => ({ ...f, math_answer: '', image_answer: '' }));
    } finally {
      setLoading(false);
    }
  };

  if (success) return (
    <AuthLayout title="Check your email" subtitle={success}>
      <Link to="/login" style={{ color: 'var(--accent)', fontSize: '14px' }}>Back to login</Link>
    </AuthLayout>
  );

  return (
    <AuthLayout title="Create account" subtitle="Enter your email to get started">
      <form onSubmit={submit}>
        {error && <Alert>{error}</Alert>}
        <FormField label="Email address" name="email" type="email" value={form.email} onChange={handle} required />
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display:'block', fontSize:'13px', fontWeight:500, marginBottom:'6px' }}>
            Math: {mathQ} =
          </label>
          <FormField name="math_answer" type="number" value={form.math_answer} onChange={handle} required />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display:'block', fontSize:'13px', fontWeight:500, marginBottom:'6px' }}>Image captcha</label>
          {captchaImg && <img src={captchaImg} alt="captcha" style={{ display:'block', marginBottom:'8px', borderRadius:'4px', border:'1px solid var(--border)' }} />}
          <FormField name="image_answer" placeholder="Enter code" value={form.image_answer} onChange={handle} required />
        </div>
        <label style={{ display:'flex', gap:'10px', alignItems:'flex-start', fontSize:'13px', color:'var(--text-muted)', marginBottom:'20px', cursor:'pointer' }}>
          <input type="checkbox" name="terms_agree" checked={form.terms_agree} onChange={handle} style={{ marginTop:'2px' }} />
          I agree to the terms and conditions
        </label>
        <Button loading={loading} type="submit">Create account</Button>
      </form>
      <div style={{ marginTop: '20px', fontSize: '13px', color: 'var(--text-muted)' }}>
        Already have an account? <Link to="/login" style={{ color: 'var(--accent)', textDecoration: 'none' }}>Sign in</Link>
      </div>
    </AuthLayout>
  );
}
